import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>Bag</ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton href="/" label="Close" dismiss />
    </ExpoRouterDemoScreen>
  );
}
